import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  Row,
  Col,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Button,
  Label,
  FormGroup,
  InputGroup,
} from "reactstrap"
import config from "../../common/configuration"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { useTranslation } from "react-i18next"
import moment from "moment"
import showToast from "../../components/Common/viewNotification"
import { cleanView, fileToUpload, sendEmail } from "../../store/actions"
const UploadFileForm = props => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    modalOpen,
    viewUploadForm,
    currentRow,
    currentUser,
    supplierSelected,
    loadFiles,
    closeModal,
  } = props
  const [expirationDate, setExpirationDate] = useState({
    value: new Date(),
    error: "",
  })
  const fi = useRef(null)
  const [selectedFilesByRow, setSelectedFilesByRow] = useState({})
  //#region  store
  const { response, loading, error } = useSelector(state => ({
    response: state.fileUpload.response,
    loading: state.fileUpload.loading,
    error: state.fileUpload.error,
  }))
  useEffect(() => {
    if (response) {
      closeModal(false)
      showToast(t("global:msgSuccessSaveList"), "success", t("global:config"))
      sendEmailTo()
      cleanning()
      loadFiles()
    }
  }, [response])
  const sendEmailTo = async () => {
    const messageHtml = `
      <body>
        <div>
          <h2>Documentos requeridos completados</h2>
          <p>
            PROVEEDOR : 
            <strong>${response?.supplier?.name?.toUpperCase()}</strong>.
          </p>
          <p>
            Informarle que se ha cumplido con todos los requisitos de documentos del area : 
            <strong>${response?.supplier?.area?.name?.toUpperCase()}</strong>.
          </p>
            
        </div>
      </body>
    `
    const listaDeEmails = response?.notificationEmails.map(user => user.email)
    let body = {
      emails: listaDeEmails,
      body: messageHtml,
    }
    if (listaDeEmails?.length) await dispatch(sendEmail(body))
  }

  const convertToBase64 = file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result)
      }
      fileReader.onerror = error => {
        reject(error)
      }
    })
  }
  const cleanning = async () => {
    await dispatch(cleanView())
  }
  const handleFileChange = async e => {
    const files = [...e.target.files]
    if (files.length === 0) return
    selectedFilesByRow[currentRow.id] = files
  }

  const handleUpload = async rowId => {
    const files = selectedFilesByRow[currentRow.id] || []
    if (files.length === 0) {
      showToast(t("filesUpload:errorUpload"), "error", t("error:title"))
      return
    }
    const fileList = []
    for (let i = 0; i < files.length; i++) {
      const base64 = await convertToBase64(files[i])
      fileList.push({
        base: base64,
        name: files[i].name,
        ext: files[i].name.split(".").pop(),
      })
    }
    await dispatch(
      fileToUpload({
        fileList: fileList,
        fileUploadId: currentRow,
        user: currentUser,
        expirationDate: expirationDate.value,
        supplier: supplierSelected ? supplierSelected : null,
      })
    )
  }
  const onchangeDate = React.useCallback((selectedDates, dateStr, instance) => {
    if (instance?.element?.name === "expirationDate") {
      setExpirationDate({ value: new Date(selectedDates) })
    }
  }, [])
  return (
    <>
      <Modal
        size="xl"
        isOpen={modalOpen}
        toggle={viewUploadForm}
        backdrop={"static"}
      >
        <ModalHeader
          toggle={modalOpen}
          tag="h4"
          close={<span></span>}
          className="d-flex justify-content-between align-items-center"
        >
          <div>{t("filesUpload:titleModal")}</div>
          <small className="text-muted ms-3">{currentRow?.fileName}</small>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={3}>
              <FormGroup className="mb-3">
                <Label for="expirationDate" className="form-label fw-bold">
                  Fecha de expiración <span className="text-danger">*</span>
                </Label>
                <InputGroup>
                  <Flatpickr
                    name="expirationDate"
                    className="form-control d-block"
                    value={moment(expirationDate.value).format("DD-MM-YYYY")}
                    options={config.form.flatpickr}
                    onChange={onchangeDate}
                    disabled={loading}
                    ref={fi}
                  />
                  <button
                    className="btn btn-primary"
                    type="button"
                    disabled={loading}
                    onClick={() => {
                      if (!fi?.current?.flatpickr) return
                      fi.current.flatpickr.open()
                    }}
                  >
                    <i className=" fas fa-calendar me-1 "></i>
                  </button>
                </InputGroup>
              </FormGroup>
            </Col>
            <Col xs={6}>
              <div>
                <Label htmlFor="name">{t("filesUpload:titleFile")}</Label>

                <Input type="file" name="file" onChange={handleFileChange} />
              </div>
            </Col>
            <Col xs={3}>
              <div>
                <Label htmlFor="name">{t("filesUpload:titleUpload")}</Label>
              </div>
              <div>
                <Button
                  onClick={() => {
                    handleUpload()
                  }}
                  color="primary"
                  disabled={loading}
                >
                  {" "}
                  <i className="fa fa-upload"></i>
                  {"   "} {t("filesUpload:titleUpload")}
                </Button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="modal-footer">
                <ButtonGroup>
                  <button
                    type="button"
                    disabled={loading}
                    className="btn btn-danger"
                    onClick={() => {
                      viewUploadForm(false)
                    }}
                  >
                    {" "}
                    {t("global:close")}
                  </button>
                </ButtonGroup>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  )
}
export default UploadFileForm
